import getTBWStore from "../../../stores/tbw-store";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import ET3Div from "../../et3-div";
import Et3Text from "../../et3-text";
import PopUpCloseButton from "../../et3-shared-components/action-buttons/popUpCloseButton";

const AlertTBWPopupHeader = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const headerText = getTBWStore().TBWHeader.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={1000}
      height={100}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="center"
        alignItems="flex-end"
        withShadow={false}
        width={920}
        height={60}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={20}
          text={`${headerText}`}
          isSpan={false}
          color={colors.all.black}
          style={{}}
        />
      </ET3Div>
      <PopUpCloseButton onClick={() => getTBWStore().resetTBWPopUp()} />
    </ET3Div>
  );
});
export default AlertTBWPopupHeader;
